/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FastField, Field, FieldArray, Form, Formik } from 'formik';
import Button from "components/Button";
import { SelectField } from '@fitinsur/components';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    DialogSelect,
    ButtonsRow,
    DialogConfirm,
} from './styles';

const mc = new MessageCenter();
const fitinsurApi = new FitinsurAPI();

export default function ModalLost({ idOperation, show, setDialog, history, title }) {
    const [visible, setVisible] = useState(show);
    const [lostDeal, setLostDeal] = useState({ formated: [], array: [] });

    const authContext = useContext(GlobalAuthContext);
    const myRef = useRef();
    const lostReasonsRef = useRef();

    useEffect(() => {
        setVisible(show);
    }, [show]);

    useEffect(() => {
        async function request() {
            fitinsurApi.setAuthToken(authContext.token);
            const data = await fitinsurApi.requestLostDealList(516).then((response) => response.json());

            try {
                if (data.ret_code != 200) {
                    mc.error("fitGetLostReason - REQUEST ERROR => " + JSON.stringify(data))
                    console.log(data);
                    return;
                }

                if (data.ret_value) {
                    const formatedOptions = data.ret_value.map(listOption => ({
                        label: listOption.ANSWER_OPTION_DESCRIPTION,
                        value: listOption.ID_ANSWER_OPTION
                    }));
                    setLostDeal({ formated: formatedOptions, array: data.ret_value });
                } else {
                    console.log("fitGetLostReason - UNEXPECTED NULL RETURNED DATA => " + JSON.stringify(data));
                }
            } catch (error) {
                mc.error("There was an error while fetching your data: \n" + error);
                console.error('fitGetLostReason - Error:', error);
                setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
            };
        }

        request();
    }, [])

    const HandleLostSubmit = (selectedID) => {
        if (!selectedID) {
            mc.error("Please, select at least one option.");
            return;
        }
        fitinsurApi.setAuthToken(authContext.token);
        fitinsurApi.updateQuoteEdit(idOperation, selectedID, 516).then(x => x.json()).then(res => {
            console.log(res)
            if (res.ret_code != 200) {
                mc.error(res.ret_msg_details);
                return;
            }
            history.push("/enquiries");
            /* setDialog({ visible: false, title: null, icon: null, args: null });
            lostReasonsRef.current.setFieldValue('reasons', ''); */
        })
    }

    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon>
                    {/* <FontAwesomeIcon icon={['fas', 'times-circle']}></FontAwesomeIcon> */}
                    <DialogText>DECLINADO</DialogText>
                </DialogIcon>
                <Formik initialValues={{ reasons: '' }} innerRef={lostReasonsRef} onSubmit={(e) => { HandleLostSubmit(e.reasons); }}>
                    <Form>
                        <DialogSelect>
                            <Field
                                disabled={false}
                                name="reasons"
                                placeholder="Selecione o motivo do declínio"
                                component={SelectField}
                                options={lostDeal.formated}
                            />
                        </DialogSelect>
                        <ButtonsRow>
                            <Button
                                third
                                type="submit"
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDialog(false); lostReasonsRef.current.setFieldValue('reasons', ''); }}                        >
                                CANCELAR
                            </Button>
                            <Button
                                primary
                                type="submit"
                            >
                                CONFIRMAR
                            </Button>
                        </ButtonsRow>
                    </Form>
                </Formik>
            </DialogBody>
        </Dialog>
    );
}